import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {EventsManager} from '../../events/events.manager';

@Component({
  selector: 'app-office',
  templateUrl: './office.component.html',
  styleUrls: ['./office.component.scss'],
  standalone: false
})

export class OfficeComponent implements OnInit {
  private _destroyRef: DestroyRef = inject(DestroyRef);
  private _eventsManager: EventsManager = inject(EventsManager);

  public officeData: any = {};

  public ngOnInit(): void {
    this._eventsManager.officeUpdate
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(() => {
        this.officeData = this._eventsManager.officeInfo;
      });

    if (this._eventsManager.officeInfo) {
      this.officeData = this._eventsManager.officeInfo;
    } else if (sessionStorage['office']) {
      this.officeData = JSON.parse(sessionStorage['office']);
    }
  }
}
